import React from 'react'

const FormErrorPure = ({ message }) => {
  return (
    <span className='hint-message-error'>
      {message}
    </span>
  )
}

export default FormErrorPure
